import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Notification {
  message: string;
  action?: string;
  configuration?: NotificationConfiguration;
}

interface NotificationConfiguration {
  duration?: number;
  severity?: 'info' | 'warning' | 'error';
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private defaultConfiguration: NotificationConfiguration = {
    duration: 2500,
  };

  private notificationSubject$ = new BehaviorSubject<Notification>(null);
  readonly notification$ = this.notificationSubject$.asObservable();

  setNotification(message: string, action?: string, configuration?: NotificationConfiguration): void {
    const duration = configuration?.duration !== undefined ? configuration.duration : this.defaultConfiguration.duration;
    this.notificationSubject$.next({
      message,
      action,
      configuration: {
        ...this.defaultConfiguration,
        ...configuration,
        duration: configuration?.severity === 'error' ? 30000
          : configuration?.severity === 'warning' && duration !== null ? Math.max(duration, 30000) : duration,
      },
    });
  }
}
